import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import moment from "moment";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";

export const getAllBookings = createAsyncThunk(
  "WebBooking/FindAllWebBooking",
  async (formdata: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebBooking/FindAllWebBooking`,
        formdata,
      );

      const result = response.data?.Data;
      return result?.map((booking: any) => {
        return {
          ...booking,
          Name: `${booking?.FirstName} ${booking?.LastName}`,
          Duration: `${+booking?.NoOfNights || 0}N / ${+booking?.NoOfDays || 0}D`,
        };
      });
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching Booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const saveTempTourBooking = createAsyncThunk(
  "WebBooking/InsertTempWebBookingForAdmin",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebBooking/InsertTempWebBookingForAdmin`,
        payload,
      );

      return response.data?.Data;
    } catch (error: any) {
      console.error("Error insert tempbooking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const createPaymentOrder = createAsyncThunk(
  "RazorpayGateway/CreateOrder",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/RazorpayGateway/CreateOrder`,
        payload,
      );

      return response.data;
    } catch (error: any) {
      console.error("Payment Order Created failed:", error);
      return Promise.reject({
        message:
          error?.response?.data?.Details || "Payment Order Created failed",
      });
    }
  },
);

export const verifyPayment = createAsyncThunk(
  "RazorpayGateway/verify",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/RazorpayGateway/verify`,
        payload,
      );

      return response.data;
    } catch (error: any) {
      console.error("Payment verification failed:", error);
      return Promise.reject({
        message:
          error?.response?.data?.Details || "Payment verification failed",
      });
    }
  },
);

export const saveTourBooking = createAsyncThunk(
  "WebBooking/InsertWebBookingForAdmin",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebBooking/InsertWebBookingForAdmin`,
        payload,
      );

      return response.data?.Data;
    } catch (error: any) {
      console.error("Error insert tour booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
export const updateTourBooking = createAsyncThunk(
  "WebBooking/UpdateWebBooking",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebBooking/UpdateWebBooking`,
        payload,
      );

      return response.data?.Data;
    } catch (error: any) {
      console.error("Error update tour booking:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getPromoCodeDetails = createAsyncThunk(
  "Coupon/FindByCouponCode",
  async (CouponCode: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/Coupon/FindByCouponCode`,
        { CouponCode: CouponCode },
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        CouponCode: result.CouponCode,
        FromDate: result.FromDate ? moment(result.FromDate).toDate() : "",
        ToDate: result.ToDate ? moment(result.ToDate).toDate() : "",
        AmountType: result.AmountType,
        Amount: result.Amount,
        MaxAmount: result.MaxAmount,
        ApplyOn: result.ApplyOn,
        Percentage: result.Percentage,
        CouponImage: result.CouponImage,
        DestinationID: result.DestinationID,
        DestinationName: result.DestinationName,
        IsActive: result.IsActive ? 1 : 2,
      } as any;
    } catch (error: any) {
      // ErrorToast("Sorry! Couponcode used is not applicable at the moment");
      console.error("Error Fetching CouponCode:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getBookingDetailsByBookingNo = createAsyncThunk(
  "WebBooking/WebsitebyBookingNo",
  async (BookingNo: string) => {
    // const Request_Id = getRequestId();
    const response = await axiosApiInstance.post(
      `${API_URL}/WebBooking/WebsitebyBookingNo`,
      {
        BookingNo: BookingNo,
      },
    );
    return response.data?.Data;
  },
);

export const deleteBooking = createAsyncThunk(
  "WebBooking/DeleteWebBooking",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebBooking/DeleteWebBooking`,
        { ID },
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Booking :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const getBookingByNo = createAsyncThunk(
  "WebBooking/BookingByBookingNo",
  async (BookingNo: string) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebBooking/WebsitebyBookingNo`,
        {
          BookingNo: BookingNo,
        },
      );
      const data = response.data?.Data;

      let formattedDate = "";
      if (data.TravelDate) {
        const [day, month, year] = data.TravelDate.split("/");
        formattedDate = `${year}-${month}-${day}`;
      }

      // Create addons object
      const addonsObject: any = {};
      if (data.bookingaddons && Array.isArray(data.bookingaddons)) {
        data.bookingaddons.forEach((addon: any) => {
          // You'll need to map this correctly based on your addon IDs
          // This is a simplified version - you might need to fetch addon IDs separately
          addonsObject[`addons_${addon?.ID}`] = addon.Quantity.toString();
        });
      }

      return {
        ...data,
        FirstName: data?.FirstName || "",
        LastName: data?.LastName || "",
        MobileNo: data?.MobileNo || "",
        EmailID: data?.EmailID || "",
        AgentName: data?.AgentName || "",
        TourID: data?.TourID,
        Date: formattedDate,
        SoloCount: data?.ExtraAdultPax?.toString() || "0",
        DualRiderCount: data?.TwinSharingPax?.toString() || "0",
        BYOBCount: data?.CWBPax?.toString() || "0",
        SICCount: data?.CNBPax?.toString() || "0",
        ThreeCount: data?.ThreeSharingPax?.toString() || "0",
        FourCount: data?.FourSharingPax?.toString() || "0",
        promoCode: data?.CouponCode || "",
        ...addonsObject,
      };
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error finding Booking :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);

export const sendBookingDetailByEmail = createAsyncThunk(
  "WebBooking/SendBookingMail",
  async (payload: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/WebBooking/SendBookingMail`,
        payload,
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error sending booking detail by email:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  },
);
